'use strict';

/*
    WalkThrough

    Replace the page content with a set of slides that advertize product features.
    Users can navigate between slides using Previous and Next buttons. An
    indicator at the bottom of the slides shows which slide in the sequence the
    user is viewing. A footer appears at the bottom of each slide with a CTA
    corresponding to the user's state (state governed by data-view; this
    component is dumb with respect to user state). Slide content slides under
    footer if required.
    Note that this comonent uses the Slider component. One needs to call
    initSwiper() on the Slider component once the page is visible.

    Parameters:
        slideNames [string] - comma separated list of class names of the
          individual slides (in the order they should be shown) (required)
        alternateSlideNameVar [string] - optional global variable name that
          contains an over-riding list of slide names

    Methods (see methods for additional usage):

        show()

        hide()

        setSlideOrder()

        update()
*/

function WalkThrough() {
  this.extends = [_AccountController, _Paths];
  this.declaredClass = null;
  this.node = null;
  this.id = null;

  this.slideNames = [];
  this.slides = [];
  this.alternateSlideNameVar = '';

  this._analytics = new Analytics();
  this._history = new History();
  this._presenter = $('[data-mogo-ui=Portal]').mogo().presenter;

  this._siblings = [];

  this.init = function () {
    this._slideCount = this.slides.length;
  };

  this.initAllReady = function () {
    this._buildSlides();
    this.node.classList.add('show');
  };

  this.destroy = function () {
    this._super();
  };

  /*
      Show the walk through and hide the parent page content
  */
  this.show = function () {
    for (var i = 0; i < this._siblings.length; i++) {
      this._siblings[i].classList.add('hide');
    }
    this.node.classList.remove('hide');
  };

  /*
      Hide the walk through and show the parent page content
  */
  this.hide = function () {
    for (var i = 0; i < this._siblings.length; i++) {
      this._siblings[i].classList.remove('hide');
    }
    this.node.classList.add('hide');
  };

  /*
      Set the order of the slides.
       Arguments:
        slideNames [array]:
          Ordered list of classes that identify the slides.
  */
  this.setSlideOrder = function (newSlideNames) {
    // store slide order
    this.slideNames = newSlideNames;

    // build list of slide references
    this.slides = [];
    for (var i = 0; i < this.slideNames.length; i++) {
      this.slides.push(this.node.querySelector('.' + this.slideNames[i]));
    }

    // order slides in slide parent based on specified order
    var slideList = this.slides[0].parentNode;
    for (i = 0; i < this.slides.length; i++) {
      var slide = this.slides[i];
      slideList.appendChild(slide);
    }
  };

  /*
      Force the walkthrough to update to match current model state.
  */
  this.update = function () {
    this._presenter.updateDOM(this.node);
  };

  this._buildSlides = function () {
    // build list of siblings (that are hidden when the walkthrough is visible)
    for (var sibling = this.node.parentNode.firstChild; sibling; sibling = sibling.nextSibling) {
      if (sibling.nodeType === 1 && sibling !== this.node) {
        this._siblings.push(sibling);
      }
    }

    // "back" or "close" button ui and functionality
    var cancelBtn = this.node.querySelector('.js--walkthrough-cancel');
    if (cancelBtn) {
      cancelBtn.addEventListener('click', this._onClickCloseBtn.bind(this));
    }

    // order slides appropriately
    if (window[this.alternateSlideNameVar] && typeof window[this.alternateSlideNameVar] === 'string') {
      this.setSlideOrder(window[this.alternateSlideNameVar].split(','));
    } else {
      this.setSlideOrder(this.slideNames.split(','));
    }

    // show first slide
    this.show();
  };

  this._onClickCloseBtn = function () {
    this.hide();
    // TODO: analytics
  };
}